import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import MotifProgressBar from '@ey/motif-react-wrapper/ProgressBar';
import Tooltip from '../../../../Common/BaseComponentWrappers/MotifTooltip';
import MotifDropdown from '../../../../Common/BaseComponentWrappers/MotifDropdown';
import IconButton from '../../../../Common/BaseComponentWrappers/MotifIconButton';
import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';
import styled from 'styled-components';
import {
	GetHelixProjectFromCanvas,
	importHelixProject,
	deletePreviousHelixProjectImport
} from '../../../../../actions/HelixIntegration/engagementhelixaction';
import {labels, isNullOrUndefined} from '../../../../../util/utils';
import {
	helixConfigurationTimelineCheckmarkStatus,
	helixProjectImportStatus,
	trialBalanceCategories
} from '../../../../../util/uiconstants';
import Button from '../../../../Common/BaseComponentWrappers/MotifButton';
import EllipsesMoment from '../../../../Common/EllipsesControl/EllipseMoment';
import ReImportConfirmationModal from './Modal/ReImportConfirmationModal';
import DeletionConfirmationModal from './Modal/DeletionConfirmationModal';
import _ from 'lodash';
import {useEngagementId, useUserPreferences} from '../../../../../util/customHooks';

function ProjectImportStatus(props) {
	const dispatch = useDispatch();
	const userPreferences = useUserPreferences();
	const engagementId = useEngagementId();
	const [isDisableImportOption, setIsDisableImportOption] = useState(false);
	const [isIndeterminate, setIsIndeterminate] = useState(false);
	const [importButtonLabel, setimportButtonLabel] = useState(labels.importLabel);
	const [projectResult, setProjectResult] = useState({});
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [showDeletionConfirmationModal, setShowDeletionConfirmationModal] = useState(false);
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [importStatusDisplayLabel, setImportStatusDisplayLabel] = useState();
	const [tooltipMessage, setTooltipMessage] = useState(labels.helixImportDataEditButtonTitle);

	useEffect(() => {
		let newStatus = helixConfigurationTimelineCheckmarkStatus.Incomplete;

		let disableImport = !(
			userPreferences &&
			userPreferences.permissions &&
			userPreferences.permissions?.canImportHelixData === true &&
			props.isHelixDataImportAllowed === true
		);
		setTooltipMessage(
			disableImport
				? props.isHelixDataImportAllowed
					? labels.helixImportInsufficientPermissionsMessage
					: labels.helixImportNotAllowed
				: labels.helixImportDataEditButtonTitle
		);

		if (props.helixProjects?.length > 0) {
			//Check if user Valid and primary project present.
			if (!_.isEmpty(props.primaryProject) && props.isValidUserWithProjectAvailable === true) {
				//   Display green check mark only if data has been imported for primary project.
				setProjectResult(props.primaryProject);
				if (!_.isNull(props.primaryProject.helixProjectAttributesReadModel?.analysisPeriod)) {
					if (props.primaryProject.helixImportStatusID === helixProjectImportStatus.Completed) {
						setIsDisableImportOption(disableImport);
						setimportButtonLabel(labels.reImportLabel);
						setTooltipMessage(
							disableImport
								? props.isHelixDataImportAllowed
									? labels.helixImportInsufficientPermissionsMessage
									: labels.helixImportNotAllowed
								: labels.reImportLabel
						);
						newStatus = helixConfigurationTimelineCheckmarkStatus.Complete;
					}
					// import is inprogress or inqueue set warning icon and inprogress
					else if (
						props.primaryProject.helixImportStatusID === helixProjectImportStatus.InProgress ||
						props.primaryProject.helixImportStatusID === helixProjectImportStatus.InQueue
					) {
						newStatus = helixConfigurationTimelineCheckmarkStatus.Warning;
						setIsDisableImportOption(true);
						setTooltipMessage(labels.loading);
						setIsIndeterminate(true);
						setImportStatusDisplayLabel(labels.importInProgressLabel);
					}
					// Import has error set warning icon and error message.
					else if (props.primaryProject.helixImportStatusID === helixProjectImportStatus.Error) {
						setImportStatusDisplayLabel(labels.importHelixProjectError);
						setimportButtonLabel(labels.reImportLabel);
						setTooltipMessage(
							disableImport
								? props.isHelixDataImportAllowed
									? labels.helixImportInsufficientPermissionsMessage
									: labels.helixImportNotAllowed
								: labels.reImportLabel
						);
						setIsDisableImportOption(disableImport);
						newStatus = helixConfigurationTimelineCheckmarkStatus.Error;
					}
					//  step 1 and Step 2 are completed. only import is missing.
					else {
						// Validate if any non primary project has imported data.
						setIsIndeterminate(false);
						validateNonPrimaryProjectImport();
						setIsDisableImportOption(disableImport);
						setImportStatusDisplayLabel(labels.importHelix);
						newStatus = helixConfigurationTimelineCheckmarkStatus.Incomplete;
					}
				} else {
					//If Helix settings not save then disable import.
					setProjectResult(props.primaryProject);
					setIsDisableImportOption(true);
					validateNonPrimaryProjectImport();
					setImportStatusDisplayLabel(labels.importHelix);
					newStatus = helixConfigurationTimelineCheckmarkStatus.Incomplete;
					setIsIndeterminate(false);
				}
			} else if (props.isValidUserWithProjectAvailable === false && !_.isEmpty(props.primaryProject)) {
				if (_.isUndefined(props.primaryProject.helixProjectAttributesReadModel?.analysisPeriod)) {
					newStatus = helixConfigurationTimelineCheckmarkStatus.Incomplete;
				} else {
					newStatus = helixConfigurationTimelineCheckmarkStatus.Warning;
				}
				setProjectResult(props.primaryProject);
				validateNonPrimaryProjectImport();
				setIsDisableImportOption(true);
				setIsIndeterminate(false);
			} else {
				validateNonPrimaryProjectImport();
				setIsDisableImportOption(true);
				setIsIndeterminate(false);
			}
		}
		props.setStatus(newStatus);
	}, [props.primaryProject, props.helixProjects]);

	const handlerOnModalOpen = () => {
		setIsDisableImportOption(true);

		if (
			projectResult.isPrimary === true &&
			(projectResult.helixImportStatusID === helixProjectImportStatus.Completed || projectResult.isRetryAllowed)
		) {
			setShowConfirmationModal(true);
		} else {
			importProjectData();
		}
	};

	const importProjectData = () => {
		let projectResults = {
			...projectResult,
			helixImportStatusID: helixProjectImportStatus.InProgress,
			isRetryAllowed: false,
			projectName: props.primaryProject.projectName,
			id: props.primaryProject.id,
			primaryProject: true
		};
		setTooltipMessage(labels.loading);
		setImportStatusDisplayLabel(labels.importInProgressLabel);
		props.setStatus(helixConfigurationTimelineCheckmarkStatus.Warning);
		setIsDisableImportOption(true);
		setIsIndeterminate(true);
		setProjectResult(projectResults);

		dispatch(importHelixProject(engagementId, props.primaryProject?.id, userPreferences))
			.then(() => {
				props.setDisplayToastMessage(false);
				props.setToastMessage(labels.importInProgressMessage);
				props.setToastMessageIcon('success');
				props.setDisplayToastMessage(true);
				dispatch(
					GetHelixProjectFromCanvas(engagementId, {
						trialBalanceTypeCategory: trialBalanceCategories.Planning,
						IncludeConnections: true
					})
				);
			})
			.catch(() => {
				setIsIndeterminate(false);
				setIsDisableImportOption(false);
			});
	};

	const validateNonPrimaryProjectImport = () => {
		if (props.helixProjects?.find((a) => !isNullOrUndefined(a.helixJsonModel) && !a.isPrimary)) {
			if (
				projectResult?.helixImportStatusID == null ||
				projectResult?.helixImportStatusID === helixProjectImportStatus.NotStarted
			) {
				props.setDisplayToastMessage(true);
				props.setToastMessage(labels.projectMismatchDisplayMessageOnDataImport);
				props.setToastMessageIcon('warning');
			}
			if (!isNullOrUndefined(props.primaryProject.helixProjectAttributes?.analysisPeriod)) {
				setimportButtonLabel(labels.reImportLabel);
				setIsDisableImportOption(false);
			}
		} else {
			setimportButtonLabel(labels.importLabel);
		}
	};

	const setClickOutside = () => {
		setIsDropdownOpen(false);
	};

	const handleIconClick = () => {
		setIsDropdownOpen(true);
	};

	const handleClickDropdownItem = () => {
		setShowDeletionConfirmationModal(true);
	};

	const dropdownOptions = () => {
		return [
			{
				label: labels.deletePreviousImport,
				onClick: () => handleClickDropdownItem()
			}
		];
	};

	const deleteImportToolTip = () => {
		// if permission is missing, then show tooltip message
		return (
			<Tooltip
				className={'delete-project-tooltip'}
				variant="alt"
				placement={'bottom'}
				hideCloseButton
				allowClick={false}
				trigger={
					<span className="deletepjct-item disabled">
						<>{labels.deletePreviousImport}</>
					</span>
				}
				children={<>{labels.helixDeleteImportInsufficientPermissionsMessage}</>}
			></Tooltip>
		);
	};

	const deletePreviousImport = () => {
		dispatch(deletePreviousHelixProjectImport(engagementId, props.primaryProject?.id));
	};

	return (
		<>
			<HelixImportProjectsStatus>
				<li>
					<section
						className={
							props.status === helixConfigurationTimelineCheckmarkStatus.Complete
								? 'import-header view-importmenu'
								: 'import-header'
						}
					>
						<span className="header hide"></span>
						<span className="import-namelbl" title={labels.importEyHelixData}>
							{labels.importEyHelixData}
						</span>
					</section>
					{!_.isEmpty(projectResult) && projectResult?.helixImportStatusID === helixProjectImportStatus.Completed ? (
						<>
							<section className="imported-by">
								<span className="header">{labels.lastImportedBy + ':'}</span>
								<span title={projectResult.helixImportUserName}>{projectResult.helixImportUserName}</span>
							</section>
							<section className="imported-on">
								<span className="header">{labels.lastImportedOn + ':'}</span>
								<span>
									<EllipsesMoment
										userPreferences={userPreferences}
										date={projectResult.helixImportDate}
										fromNow={false}
										useFormat
										useLocal={false}
									/>
								</span>
							</section>
							<section className="imported-frompjct">
								<span className="header">{labels.dataImportedFromProjec + ':'}</span>
								<span title={projectResult.projectName}>{projectResult.projectName}</span>
							</section>
						</>
					) : (
						<span className="importhelix-label">
							<span className="importhelix-labeltxt" title={importStatusDisplayLabel}>
								{importStatusDisplayLabel}
							</span>
						</span>
					)}
					<section
						className={
							props.status === helixConfigurationTimelineCheckmarkStatus.Complete
								? 'import-project view-importmenu'
								: 'import-project'
						}
					>
						{isIndeterminate ? (
							<span className="loading-pjct">
								<MotifProgressBar hideLabel={true} circle isIndeterminate />
							</span>
						) : tooltipMessage !== importButtonLabel ? (
							<Tooltip
								className={'import-project-tooltip'}
								variant="alt"
								placement={'bottom'}
								hideCloseButton
								allowClick={false}
								trigger={
									<Button
										type="loader"
										variant="primary"
										onClick={handlerOnModalOpen}
										disabled={
											props.mapEntitiesBUsStatus != helixConfigurationTimelineCheckmarkStatus.Complete ||
											isDisableImportOption
										}
										isIndeterminate={isIndeterminate}
										showLabel
										title={importButtonLabel}
										buttonLabel={importButtonLabel}
									/>
								}
								children={<>{tooltipMessage}</>}
							></Tooltip>
						) : (
							<Button
								type="loader"
								variant="primary"
								onClick={handlerOnModalOpen}
								disabled={
									props.mapEntitiesBUsStatus != helixConfigurationTimelineCheckmarkStatus.Complete ||
									isDisableImportOption
								}
								isIndeterminate={isIndeterminate}
								title={tooltipMessage}
								showLabel
								buttonLabel={importButtonLabel}
							/>
						)}
					</section>
					{props.status === helixConfigurationTimelineCheckmarkStatus.Complete &&
						(tooltipMessage !== importButtonLabel ? (
							<MotifDropdown
								open={isDropdownOpen}
								id={'sectionOption'}
								aria-labelledby={'dropdown-trigger'}
								handleClickOutside={setClickOutside}
								className="import-menu"
								trigger={
									<IconButton
										id={'dropdown-trigger'}
										type="button"
										onClick={handleIconClick}
										ariaControls={'sectionOption'}
										ariaExpanded={isDropdownOpen}
										ariaLabel="dropdown trigger"
										iconSource={IconoirCustomMoreVerticalAlt}
									/>
								}
								children={deleteImportToolTip()}
							></MotifDropdown>
						) : (
							<MotifDropdown
								open={isDropdownOpen}
								id={'sectionOption'}
								aria-labelledby={'dropdown-trigger'}
								handleClickOutside={setClickOutside}
								className="import-menu"
								trigger={
									<IconButton
										id={'dropdown-trigger'}
										type="button"
										onClick={handleIconClick}
										ariaControls={'sectionOption'}
										ariaExpanded={isDropdownOpen}
										ariaLabel="dropdown trigger"
										iconSource={IconoirCustomMoreVerticalAlt}
									/>
								}
								options={dropdownOptions()}
							></MotifDropdown>
						))}
				</li>

				{showDeletionConfirmationModal && (
					<DeletionConfirmationModal
						showModal={showDeletionConfirmationModal}
						setShowModal={setShowDeletionConfirmationModal}
						ConfirmationCallback={deletePreviousImport}
					/>
				)}

				{showConfirmationModal && (
					<ReImportConfirmationModal
						showConfirmationModal={showConfirmationModal}
						setShowConfirmationModal={setShowConfirmationModal}
						CanfirmationCallback={importProjectData}
						setIsDisableImportOption={setIsDisableImportOption}
					/>
				)}
			</HelixImportProjectsStatus>
		</>
	);
}
export default ProjectImportStatus;

const HelixImportProjectsStatus = styled.ul`
	li {
		span.header {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 97%;
			line-height: normal;
		}
		.header + span {
			font-size: var(--px-14);
			color: var(--neutrals-900);
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			max-width: 97%;
			font-weight: 500;
		}
		.import-header {
			display: inline-block;
			width: 25%;
			vertical-align: top;
			span {
				display: block;
			}
			&.view-importmenu {
				vertical-align: top;
			}
			.import-namelbl {
				font-size: var(--px-16);
				font-weight: 400;
			}
		}
		.imported-by {
			display: inline-block;
			width: 25%;
			span {
				display: block;
			}
		}
		.imported-on {
			display: inline-block;
			width: 25%;
			span {
				display: block;
			}
		}
		.imported-frompjct {
			display: inline-block;
			width: 12.5%;
			span {
				display: block;
			}
			.ellipses {
				font-size: var(--px-14);
				color: var(--neutrals-900);
				font-weight: 500;
			}
		}
		.import-project {
			display: inline-block;
			width: 12.5%;
			text-align: right;
			&.view-importmenu {
				width: calc(9% - var(--px-5));
				margin-right: var(--px-5);
			}
			.motif-button {
				float: right;
				span {
					display: block;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;
					width: 100%;
				}
			}
			.motif-loader-button {
				.motif-progress-bar-wrapper {
					display: none;
				}
			}
			.loading-pjct {
				display: flex;
				justify-content: end;
				.motif-progress-bar-wrapper {
					display: flex;
					min-width: var(--px-100);
					justify-content: center;
					height: var(--px-20);
					.motif-progress-bar.motif-progress-bar-circle {
						width: var(--px-30);
						height: var(--px-30);
					}
				}
			}
		}
		.import-menu {
			display: inline-block;
			width: 3.5%;
			vertical-align: top;
			margin: 0;
			.motif-dropdown-menu {
				.deletepjct-item {
					display: flex;
					align-items: center;
					justify-content: center;
					width: max-content;
					padding: var(--px-10) var(--px-5);
					line-height: normal;
					font-size: var(--px-14);
				}
			}
		}
		.importhelix-label {
			display: inline-block;
			width: 62.5%;
			vertical-align: top;
			.importhelix-labeltxt {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 97%;
				font-size: var(--px-14);
				font-weight: 300;
			}
		}
	}
`;
